import { MyPatientAccess } from "./Permission";

export enum MyPatientFilterActionDispatchTypes {
  MY_PATIENT_FILTER_UPDATE = "MY_PATIENT_FILTER_UPDATE",
  MY_PATIENT_FILTER_RESET = "MY_PATIENT_FILTER_RESET",
}

export const myPatientTabs = {
  myPatient: {
    assignButton: true,
    assignButtonTestId: "myPatients-assignStaff-button",
    unAssignButton: false,
    removeListButton: true,
    removeListButtonTestId: "myPatients-removeList-button",
    assignButtonPermission: null,
    unAssignButtonPermission: null,
    removeListButtonPermission: `||${MyPatientAccess.MY_PATIENT_REMOVE_FROM_LIST_UPDATE}`,
  },
  allPending: {
    assignButton: true,
    assignButtonTestId: "allPending-assignStaff-button",
    unAssignButton: true,
    unAssignButtonTestId: "allPending-unAssignStaff-button",
    removeListButton: false,
    assignButtonPermission: `||${MyPatientAccess.ALL_PENDING_ASSIGN_STAFF_UPDATE}`,
    unAssignButtonPermission: null,
    removeListButtonPermission: null,
  },
  incompleteRequest: {
    assignButton: true,
    assignButtonTestId: "incompleteRequest-assignStaff-button",
    unAssignButton: false,
    removeListButton: false,
    assignButtonPermission: `||${MyPatientAccess.INCOMPLETE_ASSIGN_STAFF_UPDATE}`,
    unAssignButtonPermission: null,
    removeListButtonPermission: null,
  },
  staffingQueue: {
    assignButton: true,
    assignButtonTestId: "staffingQueue-assignStaff-button",
    unAssignButton: true,
    unAssignButtonTestId: "staffingQueue-unAssignStaff-button",
    removeListButton: true,
    removeListButtonTestId: "staffingQueue-removeList-button",
    assignButtonPermission: `||${MyPatientAccess.STAFFING_QUEUE_ASSIGN_STAFF_UPDATE}`,
    unAssignButtonPermission: `||${MyPatientAccess.STAFFING_QUEUE_UNASSIGN_STAFF_UPDATE}`,
    removeListButtonPermission: `||${MyPatientAccess.STAFFING_QUEUE_REMOVE_FROM_LIST_UPDATE}`,
  },
  pdn: {
    assignButton: true,
    assignButtonTestId: "pdn-assignStaff-button",
    unAssignButton: false,
    removeListButton: false,
    assignButtonPermission: null,
    unAssignButtonPermission: null,
    removeListButtonPermission: null,
  },
};

export const getCurrentTabBtnDetails = (activeTab: number) => {
  switch (activeTab) {
    case 0:
      return myPatientTabs.myPatient;
    case 1:
      return myPatientTabs.allPending;
    case 2:
      return myPatientTabs.incompleteRequest;
    case 3:
      return myPatientTabs.staffingQueue;
    case 4:
      return myPatientTabs.pdn;
  }
  return myPatientTabs.myPatient;
};

export enum AllPendingUnassignStaffActionDispatchTypes {
  ALL_PENDING_UNASSIGN_STAFF_ERROR = "ALL_PENDING_UNASSIGN_STAFF_ERROR",
  ALL_PENDING_UNASSIGN_STAFF_INVOKE = "ALL_PENDING_UNASSIGN_STAFF_INVOKE",
  ALL_PENDING_UNASSIGN_STAFF_SUCCESS = "ALL_PENDING_UNASSIGN_STAFF_SUCCESS",
  ALL_PENDING_UNASSIGN_STAFF_RESET = "ALL_PENDING_UNASSIGN_STAFF_RESET",
}